var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameEndingLog = function SvgIconStorygameEndingLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h8m-8 4h8m-8 4h5m-7.5 6.5h13a2 2 0 0 0 2-2v-15a2 2 0 0 0-2-2h-13a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2Z",
    stroke: "#000",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconStorygameEndingLog;